<template>
    <div class="pay-refund-container">
		<div class="content">
			<div class="card-wrapper" v-for="(item, index) in list" :key="index">
				<mobile-card :show-title="false">
					<template slot="content">
						<div class="flex-form-info">
							<span>收费项目</span>
							<span>{{item.itemName | formatSpaceText}}</span>
						</div>

						<div class="flex-form-info">
							<span>收费区间</span>
							<span>{{item.intervalName | formatSpaceText}}</span>
						</div>

						<div class="flex-form-info">
							<span>退费金额</span>
							<span class="money-item">{{item.refundMoney | formatMoney}}</span>
						</div>

						<div class="flex-form-info">
							<span>退费方式</span>
							<span>{{item.refundTypeName | formatSpaceText}}</span>
						</div>

						<div class="flex-form-info">
							<span>退费日期</span>
							<span>{{item.refundDate | formatSpaceText}}</span>
						</div>

						<div class="flex-form-info">
							<span>退费状态</span>
							<span>{{item.refundStateStr | formatSpaceText}}</span>
						</div>
					</template>
				</mobile-card>
			</div>
			<div v-if="$utils.isEmpty(list)" class="empty-block">
				<span>{{ emptyText }}</span>
			</div>
		</div>
        <div class="footer">
			<div class="footer-bar">
            	<mobile-button color="#005423" @click="onBack">返回上一级</mobile-button>
			</div>
        </div>
    </div>
</template>

<script>
    import log from "utils/log"
    import apiPayRefund from "api/pay-refund"
    import MobileCard from "components/mobile-card/index";
    import MobileButton from "components/mobile-button/index";

    export default {
		name:"payRefund",
        components: {MobileButton, MobileCard},
        data() {
            return {
				list: [],
				emptyText:'暂无数据',
            }
		},

        created() {
            this.getList()
		},
		
        methods: {
            getList() {
                let self = this
                let param = {}
                apiPayRefund.list(param).then(res => {
                    self.list = res.data || []
                    // self.list = [{
                    //     itemName: '123',
                    //     intervalName: '3434',
                    //     refundMoney: 12314,
                    //     refundTypeName: 'dfasfa',
                    //     refundDate: 'fdsafa',
                    //     refundStateStr: 'dfasdf',
                    // }]
                })
			},
			
            onBack() {
                this.$router.back()
            },
        },

    }
</script>

<style lang='scss' scoped>
    // .flex-form-info {
    //     padding: 5px;
    //     display: flex;
    //     justify-content: space-between;
    // }
</style>
